import React from 'react'
import Carousel from 'react-multi-carousel'
import { useMediaQuery } from 'react-responsive'
require('./video.css')

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 2,
    slidesToSlide: 1, // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 450 },
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 450, min: 0 },
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
  },
}
function Video() {
  const isMobile = useMediaQuery({ query: '(max-width: 450px)' })
  return (
    <>
      <div style={{ paddingLeft: "2rem", paddingRight: "2rem" }} id="video">
        <div className="video-text">गले की खराश (Sore throat) का कारण, लक्षण और इलाज - Dr. Aashima Bhalla</div>
      </div>
      <div className="feedback-carousel-container">
        <Carousel responsive={responsive} className="carousel-container">
          <div className='video' id="video">
            {isMobile ?
              <iframe src="https://www.youtube.com/embed/DLmNmjfHuc8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style={{ width: "120vh", height: "35vh" }}></iframe> :
              <iframe src="https://www.youtube.com/embed/DLmNmjfHuc8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style={{ width: "100vh", height: "56.4vh" }}></iframe>}
          </div>
          <div className='video' id="video">
            {isMobile ?
              <iframe src="https://www.youtube.com/embed/ejLt0H7GZMA" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style={{ width: "120vh", height: "35vh" }}></iframe> :
              <iframe src="https://www.youtube.com/embed/ejLt0H7GZMA" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style={{ width: "100vh", height: "56.4vh" }}></iframe>}
          </div>
        </Carousel>
      </div>
    </>
  )
}

export default Video
